import { makeStyles } from '@material-ui/styles';

const VIEWPORT_OFFSET = 340;
const VIDEO_MIN_WIDTH = 480;

export const useStyles = makeStyles((theme) => ({
  content: {
    marginBottom: theme.spacing(2),
  },
  description: {
    marginBottom: theme.spacing(2),
  },
  empty: {
    padding: theme.spacing(4, 0),
    textAlign: 'center',
  },
  videoFrame: {
    width: '100%',
    maxWidth: `max(${VIDEO_MIN_WIDTH}px, calc((100vh - ${VIEWPORT_OFFSET}px) * 16 / 9))`,
    margin: '0 auto',
  },
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0,
    overflow: 'hidden',
    '& iframe': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 0,
    },
  },
  pdf: {
    width: '100%',
    height: `calc(100vh - ${VIEWPORT_OFFSET}px)`,
    minHeight: 400,
    border: 0,
  },
  image: {
    maxWidth: '100%',
  },
  audio: {
    width: '100%',
  },
}));
